import { get } from './http'

export const gtmEvent = (type, rowSystemId, quantity = 1) => {
    return get('/api/cart')
        .then((response) => response.json())
        .then((cart) => pushDataToGtm(type, cart, rowSystemId, quantity))
}

function pushDataToGtm(type, cart, rowSystemId, quantity) {
    var currentProduct = cart.orderRows.find(
        (p) => p.rowSystemId == rowSystemId
    )

    var eventType = 'addToCart'
    if (type === 'remove') {
        eventType = 'removeFromCart'
    }

    var data = `{
        "event": "${eventType}",
        "ecommerce": {
            "currencyCode": "${currentProduct.currencyCode}",
            "${type}": {
                "products": [{
                    "name":     "${currentProduct.name}",
                    "id":       "${currentProduct.articleNumber}",
                    "price":    "${currentProduct.gaFromattedPrice}",
                    "brand":    "${currentProduct.brand}",
                    "category": "${currentProduct.categoryName}",
                    "quantity": "${quantity}"
                }]
        }
    }}`

    return window.dataLayer.push(JSON.parse(data))
}

export function pushKlaviyoAddToCartEvent(articleNumber, quantity, cart) {
    const items = cart.orderRows.map(row => row.klaviyoOrderRow);
    const itemNames = cart.orderRows.map(row => row.name);
    var currentProduct = cart.orderRows.find(
        (p) => p.articleNumber == articleNumber
    )

    var data = {
        "event": "klaviyoAddedToCart",
        "ecommerce": {
            "value": cart.orderTotalNum,
            "addedItemProductName": currentProduct.klaviyoOrderRow.productName,
            "addedItemProductId": currentProduct.klaviyoOrderRow.productId,
            "addedItemSKU": currentProduct.klaviyoOrderRow.sku,
            "addedItemCategory": currentProduct.klaviyoOrderRow.category,
            "addedItemImageUrl": currentProduct.klaviyoOrderRow.imageUrl,
            "addedItemURL": currentProduct.klaviyoOrderRow.productUrl,
            "addedItemPrice": currentProduct.klaviyoOrderRow.itemPrice,
            "addedItemQuantity": quantity,
            "itemNames": itemNames,
            "checkoutUrl": cart.checkoutFullUrl,
            "items": items
    }};

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
}
